import React from 'react';
import styled from 'react-emotion';
import { Link } from 'react-router-dom';
import {
  Button,
  Paper,
  Typography as _Typography,
} from 'material-ui';

import { 
  MOBILE_WIDTH,
  PATHS as paths,
} from '../lib/constants';

const Container = styled(Paper)`
  padding: 0 2em;
  height: 100px;
  line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;

  @media all and (min-width: ${MOBILE_WIDTH}px) {
    text-align: left;
    flex-direction: row;
  }
`; 

const Typography = styled(_Typography)`
  line-height: 100px !important;
`;


export const Footer = () => (
  <Container>
      <Typography type="body2">
        &copy; {new Date().getFullYear()} Emory Labs LLC
      </Typography>
    <div>
      <Button component={Link} to={paths.terms}>
        Terms of Use
      </Button>
      <Button component={Link} to={paths.privacy}>
        Privacy Policy
      </Button>
    </div>
  </Container>
);


// WEBPACK FOOTER //
// ./src/components/Footer.jsx